<template>
  <section>
    <div class="container py-5">
      <div class="row d-flex align-items-stretch g-5">
        <div
          v-for="(article, i) in articles"
          :key="i"
          class="col-12 col-lg-6 mb-5 mb-lg-0"
          :class="
            articles.length > 2 && i === 2
              ? 'col-lg-12 row h-100 gx-4 mx-0'
              : ''
          "
        >
          <div
            v-if="articles.length > 2 && i === 2"
            :class="articles.length > 2 && i === 2 ? 'col-lg-6 mb-5' : ''"
          >
            <div class="ratio ratio-636x667">
              <img
                src="../../../../assets/images/girl.png"
                alt="smiling-girl-image"
              />
            </div>
          </div>
          <blog-article
            :class="articles.length > 2 && i === 2 ? 'col-lg-6 px-lg-4' : ''"
            class="h-100 d-flex flex-column pb-lg-5"
            :article="article"
          />
        </div>
      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: "BlogArticlesSection",
};
</script>
<script setup>
import { defineProps } from "vue";
import BlogArticle from "@/components/blog/index/background-card/BlogArticle";

defineProps({
  articles: {
    type: Array,
  },
});
</script>

<style scoped lang="scss"></style>
